export function isArray<T>(value: unknown): value is readonly T[] {
  return Array.isArray(value);
}

export function assertIsArray<T>(
  value: unknown
): asserts value is readonly T[] {
  if (!isArray(value)) {
    throw new TypeError(`Value is not of type array.`);
  }
}
